// extracted by css-extract-rspack-plugin
export default {"cls1":"FocusedNavView-cls1_gYz","cls2":"FocusedNavView-cls2_xOE FocusedNavView-cls1_gYz"};